import { createContext } from 'react';

import type { FileSystemProps } from '../props';

export const FileSystemContext = createContext<
  Pick<FileSystemProps, 'onItemClick' | 'onItemContextMenu'>
>({});
